(function () {
  "use strict";
  if (window.__nagKitTail) return;
  window.__nagKitTail = 1;

  /* ==========================================================
     NAGAIA kit builder -- paginate tail  v1  (2026-08-24)

     WHY THIS FILE EXISTS

     Liquid's {% paginate %} is hard-capped at 250 items per page. It does
     NOT error when you ask for more -- sections/nagaia-kit-builder.liquid
     has said "by 300" since v20 and Shopify has been silently handing back
     250. Confirmed against shopify.dev: the `by` argument is documented as
     1..250, and the cap applies to every Liquid construct, so there is no
     rewrite of that loop that reaches item 251. This is the only way past
     it short of splitting the collection.

     WHAT WAS BROKEN

     kit-only-dont-delete crossed 250 products some time ago (292 today).
     The picker was therefore built from the first 250 in ALPHA order only:
     41 shades from "Starlight Gleam" to "Zesty Lemon" -- White, Wild Berry,
     Vintage Rose, Teal Treasures, Twilight Dusk, Zesty Lemon among them --
     could not be picked into a kit at all. Nothing logged, nothing looked
     wrong; the wall just ended early.

     dip-powder (283) hits the same ceiling in the second script, so ~33
     colours were missing from NKB_HANDLES. That one is quieter: a miss
     only drops the swatch back to the old single-image zoom instead of the
     shared gallery, which is exactly the "I only see the swatch, never the
     nails" complaint v27C set out to fix.

     THE ONE RULE THIS FILE MUST OBEY

     FAIL CLOSED. Every failure path -- endpoint gone, non-200, bad JSON,
     missing field, wrong shape -- leaves NKB_COLORS exactly as Liquid built
     it, i.e. today's behaviour. It appends and re-renders or it does
     nothing. It must never empty the picker: that failure mode has been
     hit twice already (v25 whitelists, v27's dropped brace) and is
     indistinguishable at a glance from a broken whitelist.

     It also never touches the first 250. Those are server-rendered and
     paint before this file runs, so first paint is unchanged.
     ========================================================== */

  var CAP = 250;          /* Liquid's ceiling, and products.json's too */
  var MAX_PAGES = 6;      /* 1500 products; a runaway loop is worse than a gap */

  var COLOR_TAGS = ["Pink", "Red", "Purple", "Blue", "Green", "Nude/Neutral",
    "White", "Brown", "Yellow/Golden", "Orange", "Black/Dark", "Gray/Silver",
    "Heat Sensitive"];

  /* Must stay identical to the color_tags list in the Liquid loop. If a new
     colour family is ever added there, add it here in the same breath or the
     tail silently drops that family. */

  /* Liquid renders swatches with | img_url: '300x300'. Same box here so the
     tail shares the browser cache with the head instead of pulling the
     3024x3024 original for an 80px swatch. */
  function sized(src, px) {
    if (!src) return "";
    if (/_\d+x\d*(_crop_\w+)?\.\w+(\?|$)/.test(src)) return src;
    return src.replace(/(\.\w+)(\?|$)/, "_" + px + "x" + px + "$1$2");
  }

  /* products.json hands tags back as an array, but a comma string on some
     endpoints. Accept both rather than trust one. */
  function colorOf(tags) {
    var list = tags;
    if (typeof list === "string") list = list.split(",");
    if (!list || !list.length) return null;
    for (var i = 0; i < list.length; i++) {
      var t = String(list[i]).trim();
      if (COLOR_TAGS.indexOf(t) !== -1) return t;
    }
    return null;
  }

  function fetchPage(handle, n) {
    return fetch("/collections/" + handle + "/products.json?limit=" + CAP + "&page=" + n,
                 { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        return (d && d.products && d.products.length) ? d.products : null;
      })
      .catch(function () { return null; });
  }

  function tailPages(total) {
    var out = [], n = 2;
    while ((n - 1) * CAP < total && n <= MAX_PAGES) { out.push(n); n++; }
    return out;
  }

  function eachTailProduct(handle, total, onProduct, onDone) {
    if (!total || total <= CAP) return;
    var pages = tailPages(total);
    if (!pages.length) return;
    Promise.all(pages.map(function (n) { return fetchPage(handle, n); }))
      .then(function (sets) {
        for (var i = 0; i < sets.length; i++) {
          if (!sets[i]) continue;
          for (var j = 0; j < sets[i].length; j++) {
            try { onProduct(sets[i][j]); } catch (e) {}
          }
        }
        if (onDone) onDone();
      })
      .catch(function () {});
  }

  function topUpColors() {
    var ALL = window.NKB_COLORS;
    if (!ALL || typeof ALL.push !== "function") return;
    var seen = {}, added = 0;
    for (var i = 0; i < ALL.length; i++) seen[ALL[i].id] = 1;

    eachTailProduct("kit-only-dont-delete", window.NKB_KIT_TOTAL || 0, function (p) {
      var tag = colorOf(p.tags);
      if (!tag) return;
      var v = (p.variants || [])[0], im = (p.images || [])[0];
      if (!v || !v.id || !im || !im.src) return;
      if (seen[v.id]) return;
      seen[v.id] = 1;
      ALL.push({
        id: v.id,
        name: String(p.title || "").replace(/\s*kit only\s*$/i, "").trim(),
        img: sized(im.src, 300),
        sku: v.sku || "",
        color: tag
      });
      added++;
    }, function () {
      /* nkbRerender is renderAll() inside the section. ALL is the very array
         the section closed over, so the pushes above are already visible to
         it -- this only asks it to repaint. If the hook is missing (older
         section) the new colours simply wait for the next tab/search redraw
         rather than breaking anything. */
      if (added && typeof window.nkbRerender === "function") window.nkbRerender();
    });
  }

  function topUpHandles() {
    var H = window.NKB_HANDLES;
    if (!H || typeof H !== "object") return;
    eachTailProduct("dip-powder", window.NKB_MAIN_TOTAL || 0, function (p) {
      if (!p.handle) return;
      (p.variants || []).forEach(function (v) {
        if (v && v.sku && !H[v.sku]) H[v.sku] = p.handle;
      });
    });
  }

  function go() { topUpColors(); topUpHandles(); }

  /* This file is deferred, so the section's inline scripts have already run
     and NKB_COLORS / nkbRerender exist by now. The readyState guard is only
     for the case where someone drops the tag in without defer. */
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", go);
  } else {
    go();
  }
})();
